// extracted by mini-css-extract-plugin
export default {"buttonSubmitContainer":"ButtonSubmitPaypal_buttonSubmitContainer__NhfeU","button":"ButtonSubmitPaypal_button__muDGb"};